import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import ResourceSelectDialog from "./ResourceSelectDialog";
import { setCustomSelectOpen } from "../../store/reducers/customSelect";
import { useAppDispatch } from "../../store/hooks";
import Cooks from "../Cooks/Cooks";
import { CookDetailTypeEnumChefForParty } from "../../enums/CookDetailTypeEnumChefForParty";
import {ErrorDialog} from "./ErrorDialog";
import httpClient from "../../HttpClient";
import { useNavigate } from "react-router-dom";
import { DateTimePicker } from "@mui/x-date-pickers";
import ChefForPartyService from "../../services/ChefForPartyService";

const chefForPartyService = new ChefForPartyService();

interface InputProps {
  data: any;
  open: boolean;
  setOpen: (open: boolean) => any;
  trialId: string;
  cook?: any;
}


const AssignCookOnChefForParty = (props: InputProps) => {
  const [selectedCook, setSelectedCook] = useState<any>(props.cook ?? null);
  const [cookCut, setCookCut] = useState<string>("0");
  const [helperCost, setHelperCost] = useState<string>('0');
  const [travelAllowance, setTravelAllowance] = useState<string>('0');
  const [extraTimePayment, setExtraTimePayment] = useState<string>('0');
  const [allocationNotes, setAllocationNotes] = useState<string>("");
  const [type, setType] = useState<string>("")
  const dispatch = useAppDispatch();
  const [openError, setOpenError] = useState<boolean>(false);
  const [errorRes, setErrorRes] = useState<any>();
  const [arrivalTime, setArrivalTime] = useState<Date | null>(null);
  const [chefStaysTill, setChefStaysTill] = useState<Date | null>(null);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleClose = async (recordData: any) => {
    setSelectedCook(recordData);
  };

  const handleSelectCook = () => {
    dispatch(
      setCustomSelectOpen({
        open: true,
      })
    );
  };

  React.useEffect(() => {
    if (props.cook) {
      setSelectedCook(props.cook);
    }
  }, [props.cook]);

  const handleSubmit = () => {
    if(!selectedCook) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: `Select a Cook`,
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }
    if(cookCut === '') {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: `Enter cook cut`,
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }
    if(type === '') {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: `Enter cook type`,
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }
    let payload = {
      cookId: selectedCook.id,
      cookCut: cookCut,
      helperCost: helperCost,
      travelAllowance: travelAllowance,
      extraTimePayment: extraTimePayment,
      allocatorComments: allocationNotes,
      type,
      arrivalTime: arrivalTime,
      staysTill: chefStaysTill
    };
    const partyId = parseInt(props?.data?.id);
    setSubmitting(true);
    httpClient.patch(`/centaurus/chef-for-party/${partyId}/assign-cook`, payload).then(async (res) => {
      if (res) {
        const cooks: any[] = res?.data?.cooks || [];
        const matchedDetails = cooks
          .filter((c) => c?.profile?.id === selectedCook.id)
          .map((c) => c?.details)
          .filter(Boolean)
          .sort((a: any, b: any) => (b?.id || 0) - (a?.id || 0))[0];
        const cookDetailsId = matchedDetails?.id;

        if (cookDetailsId) {
          try {
            await chefForPartyService.approvalChefForParty(partyId, {
              accepted: true,
              reason: "",
              cookId: selectedCook.id,
              cookDetailsId,
            });
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: "Vendor assigned and accepted",
              type: CustomSnackbarTypes.SUCCESS,
            });
          } catch (e) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: "Vendor assigned, but auto-accept failed",
              type: CustomSnackbarTypes.WARNING,
            });
          }
        } else {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Success",
            type: CustomSnackbarTypes.SUCCESS,
          });
        }

        window.location.reload();
        navigate(`/ChefForParty/${partyId}/show/3`);
      }
      setCookCut("0");
      setHelperCost('0');
      setTravelAllowance('0');
      setExtraTimePayment('0');
      setSelectedCook(null);
      props.setOpen(false);
      setAllocationNotes('');
      setChefStaysTill(null);
      setArrivalTime(null);
    })
        .catch((err) => {
          setErrorRes(err?.response?.data?.data);
          if(err?.response?.data?.data){
            setOpenError(true);
          }
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: err?.response?.data?.data ? `` : err?.response?.data?.error,
            type: CustomSnackbarTypes.ERROR,
            duration:  err?.response?.data?.data ? 0 : 3000,
          });
        })
        .finally(() => {
          setSubmitting(false);
        });
  };

  return (
    <div>
      {!!props.open && (
        <ResourceSelectDialog
          name={"Cooks"}
          list={Cooks}
          onClose={handleClose}
        />
      )}
      <Dialog
        open={props.open}
        scroll={"paper"}
        maxWidth="xs"
        fullWidth
        disableEscapeKeyDown={submitting}
      >
        <DialogTitle>Assign Vendor</DialogTitle>
        <DialogContent sx={{ position: "relative" }}>
          {submitting && (
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(255,255,255,0.7)",
                zIndex: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
              }}
            >
              <CircularProgress />
              <span style={{ fontSize: 13, color: "#475569" }}>
                Assigning vendor…
              </span>
            </Box>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="cookType">Vendor Type</InputLabel>
              <Select
                labelId="cookType"
                id="cookType"
                value={type}
                label="Vendor Type"
                onChange={(event: any) => {
                  setType(event.target.value);
                }}
              >
                {Object.values(CookDetailTypeEnumChefForParty).map((e) => (
                  <MenuItem key={e} value={e}>
                    {e}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {
              !props.cook && (
                <Button
                  variant={"contained"}
                  color={"primary"}
                  onClick={handleSelectCook}
                >
                  Select Vendor
                </Button>
              )
            }
            {!!selectedCook && (
              <p>Selected vendor - {selectedCook?.fname +' '+selectedCook?.lname}</p>
            )}
            <TextField
              value={cookCut}
              type={"number"}
              label={ "Vendor Cut"}
              style={{
                marginTop: "12px",
              }}
              onChange={(event) => {
                setCookCut(event.target.value);
              }}
            />
            <TextField
              value={helperCost}
              type={"number"}
              label={"Helper Cost"}
              style={{
                marginTop: "12px",
              }}
              onChange={(event) => {
                setHelperCost(event.target.value);
              }}
            />  
            <TextField
              value={travelAllowance}
              type={"number"}
              label={"Travel Allowance"}
              style={{
                marginTop: "12px",
              }}
              onChange={(event) => {
                setTravelAllowance(event.target.value);
              }}
            />
            <TextField
              value={extraTimePayment}
              type={"number"}
              label={"Extra Time Payment"}
              style={{
                marginTop: "12px",
              }}
              onChange={(event) => {
                setExtraTimePayment(event.target.value);
              }}
            />
            <TextField
              value={allocationNotes}
              type={"string"}
              label={'Allocation Notes'}
              style={{
                marginTop: "12px",
              }}
              onChange={(event) => {
                setAllocationNotes(event.target.value);
              }}
            />
            <span style={{fontStyle: 'italic', color:"red"}}>* Not Necessary to fill these fields</span>
            <DateTimePicker
              label="Arrival Time"
              inputFormat="dd MMM yyyy HH:mm:ss"
              value={arrivalTime}
              disableMaskedInput
              onChange={(newValue) => {
                setArrivalTime(newValue);
              }}
              renderInput={(params) => {
                return <TextField {...params} />;
              }}
            />
            <DateTimePicker
              label="Chef Stays Till Time"
              inputFormat="dd MMM yyyy HH:mm:ss"
              value={chefStaysTill}
              disableMaskedInput
              onChange={(newValue) => {
                setChefStaysTill(newValue);
              }}
              renderInput={(params) => {
                return <TextField {...params} />;
              }}
            />
          </div>
        </DialogContent>
        <DialogActions style={{ marginTop: "12px" }}>
          <Button
            variant="contained"
            onClick={() => {
              handleSubmit();
            }}
            size={"large"}
            disabled={submitting}
            startIcon={
              submitting ? (
                <CircularProgress size={16} color="inherit" />
              ) : undefined
            }
          >
            {submitting ? "Assigning…" : "Submit"}
          </Button>
          <Button
            variant="contained"
            color={"error"}
            onClick={() => {
              props.setOpen(false);
              setCookCut("0");
              setSelectedCook(null);
              setAllocationNotes('');
              setChefStaysTill(null);
              setArrivalTime(null);
              setHelperCost('0');
              setTravelAllowance('0');
              setExtraTimePayment('0');
            }}
            size={"large"}
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <ErrorDialog
          open={openError}
          onClose={() => {setOpenError(false)}}
          data={errorRes}
      />
    </div>
  );
};

export default AssignCookOnChefForParty;
